import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { StateService } from '../services/state/state.service';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(
    private readonly stateService: StateService,
    private readonly router: Router
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const isAuthenticated = this.stateService.isUserLoggedIn();

    if (isAuthenticated) {
      void this.router.navigate(['/login/role'], {
        queryParams: { redirect: route.queryParamMap.get('redirect') },
      });

      return false;
    }

    return true;
  }
}
